import { Box, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { RENTAL_PRICE_BASIS_TRANSLATION_KEYS } from '@/constants/rentalPrice';
import useFormatMessage from '@/hooks/useFormatMessage';
import useFormatPrice from '@/hooks/useFormatPrice';

const Price = ({ price, priceBasis, initialPrice }) => {
  const formatMessage = useFormatMessage();
  const formatPrice = useFormatPrice();

  if (!price) {
    return (
      <Typography
        data-test-subject="price-placeholder"
        component="div"
        color="primary.main"
        variant="body1Redesign">
        {formatMessage('rental_price_placeholder')}
      </Typography>
    );
  }

  return (
    <Stack direction="row" alignItems="baseline" columnGap={1} flexWrap="wrap">
      {initialPrice && (
        <Typography
          data-test-subject="initial-price"
          component="div"
          color="grayscale.500"
          variant="body1Redesign"
          sx={{ textDecoration: 'line-through' }}>
          {formatMessage('rental_price_from', {
            price: formatPrice(initialPrice),
          })}
        </Typography>
      )}
      <Box>
        <Typography
          data-test-subject="price"
          component="span"
          color="primary.main"
          variant="body1Redesign">
          {formatMessage('rental_price_from', {
            price: formatPrice(price),
          })}
        </Typography>
        <Typography
          data-test-subject="price-basis"
          component="span"
          typography="captionRedesign"
          color="primary.main"
          ml={1}>
          {`${formatMessage(
            priceBasis
              ? RENTAL_PRICE_BASIS_TRANSLATION_KEYS[priceBasis]
              : 'rental_price_basis_day'
          )}`}
        </Typography>
      </Box>
    </Stack>
  );
};

Price.propTypes = {
  price: PropTypes.number,
  priceBasis: PropTypes.string,
  initialPrice: PropTypes.number,
};

export default Price;
